"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _SecondaryButton = _interopRequireDefault(require("../Buttons/SecondaryButton"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var propTypes = {
  /** Rendered page index */
  pageIndex: _propTypes["default"].number.isRequired,
  /** How many rows are rendered per page */
  pageSize: _propTypes["default"].number.isRequired,
  /** Rendered page with rows */
  page: _propTypes["default"].array.isRequired,
  /** Number of all accounts */
  total: _propTypes["default"].number.isRequired,
  /** Can navigate to next page (false if the last page is rendered) */
  canNextPage: _propTypes["default"].bool.isRequired,
  /** Can navigate to prev page (false if the first page is rendered) */
  canPreviousPage: _propTypes["default"].bool.isRequired,
  /** Change page using this method */
  gotoPage: _propTypes["default"].func.isRequired
};
var PaginationText = function PaginationText(_ref) {
  var pageIndex = _ref.pageIndex,
    pageSize = _ref.pageSize,
    page = _ref.page,
    total = _ref.total,
    canNextPage = _ref.canNextPage,
    canPreviousPage = _ref.canPreviousPage,
    gotoPage = _ref.gotoPage;
  var showingFrom = pageIndex * pageSize;
  var pageRecords = canNextPage ? showingFrom + pageSize : showingFrom + page.length;
  var showingTo = pageIndex > 0 ? pageRecords : page.length;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    p: "base",
    gap: "base",
    center: true
  }, /*#__PURE__*/_react["default"].createElement(_SecondaryButton["default"], {
    w: "90px",
    disabled: !canPreviousPage,
    onClick: function onClick() {
      return gotoPage(pageIndex - 1);
    },
    pV: "xxs"
  }, "Prev"), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, "Showing ".concat(pageIndex > 0 ? showingFrom + 1 : 1, " to ").concat(showingTo, " of ").concat(total, " entries")), /*#__PURE__*/_react["default"].createElement(_SecondaryButton["default"], {
    w: "90px",
    disabled: !canNextPage,
    onClick: function onClick() {
      return gotoPage(pageIndex + 1);
    },
    pV: "xxs"
  }, "Next"));
};
PaginationText.propTypes = propTypes;
var _default = PaginationText;
exports["default"] = _default;